module.exports = __webpack_public_path__ + "hk.a3c11d10c1b9c14766c4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/hk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/hk.svg
// module chunks = styles